export default __webpack_public_path__ + "static/media/dataSci.7c16ddda.png";